import { useState, useEffect } from 'react'
import { fetchHPOTerms } from 'src/api/filters/hpo'

/**
 * Custom hook for managing HPO term selection
 */
export const useHPOSelection = (initialHpoTerms = [], onTermsChange = null) => {
  const [hpoTerms, setHpoTerms] = useState(initialHpoTerms)

  /**
   * Wrapper for setHpoTerms that also calls onTermsChange if provided
   */
  const updateHpoTerms = (newTerms) => {
    setHpoTerms(newTerms)
    if (onTermsChange && typeof onTermsChange === 'function') {
      onTermsChange(newTerms)
    }
  }

  /**
   * Convert HPO terms array to comma-separated string
   * @returns {string} Comma-separated HPO terms
   */
  const getHpoTermsAsString = () => {
    if (!hpoTerms || hpoTerms.length === 0) return ''
    return hpoTerms.map((term) => term.hpo_id).join(', ')
  }

  /**
   * Get HPO terms as an array of HPO IDs
   * @returns {string[]} Array of HPO IDs
   */
  const getHpoIds = () => {
    if (!hpoTerms || hpoTerms.length === 0) return []
    return hpoTerms.map((term) => term.hpo_id)
  }

  /**
   * Get HPO terms as an array of HPO names
   * @returns {string[]} Array of HPO names
   */
  const getHpoNames = () => {
    if (!hpoTerms || hpoTerms.length === 0) return []
    return hpoTerms.map((term) => term.name)
  }

  /**
   * Parse comma-separated string into HPO terms array
   * @param {string} hpoString - Comma-separated HPO terms
   */
  const setHpoTermsFromString = async (hpoString) => {
    // TODO: Probably not needed anymore
    // if (!hpoString) {
    //   updateHpoTerms([])
    //   return
    // }
    // // Split the string by commas and trim whitespace
    // const hpoIds = hpoString.split(',').map((id) => id.trim())
    // // Fetch HPO terms data for the IDs
    // try {
    //   const results = []
    //   for (const id of hpoIds) {
    //     if (id.startsWith('HP:')) {
    //       const response = await fetchHPOTerms({ search: id })
    //       const match = response.find((term) => term.hpo_id === id)
    //       if (match) {
    //         results.push({
    //           value: match.hpo_id,
    //           label: `${match.name} (${match.hpo_id})`,
    //           name: match.name,
    //           hpo_id: match.hpo_id,
    //           synonyms: match.synonyms || [],
    //         })
    //       }
    //     }
    //   }
    //   updateHpoTerms(results)
    // } catch (error) {
    //   console.error('Error fetching HPO terms:', error)
    // }
  }

  return {
    hpoTerms,
    setHpoTerms: updateHpoTerms,
    getHpoTermsAsString,
    setHpoTermsFromString,
    getHpoIds,
    getHpoNames,
  }
}

export default useHPOSelection
